/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'GoalPanel.header.title': 'Mål',
  'goal-panel.generic-error.description': 'Kontrollér din internetforbindelse, og prøv igen.',
  'goal-panel.generic-error.title': 'Noget gik galt',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'Vis flere felter',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': 'Vis mindre',
  'goal-panel.goal-panel-tabs.about-tab-title': 'Om',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'Projekter',
  'goal-panel.goal-panel-tabs.updates-tab-title': 'Opdateringer',
  'goal-panel.goal-title.edit-button-label': 'Rediger måltitel',
  'goal-panel.goal-title.update-error-description': 'Kunne ikke opdatere indholdet for {goalName}',
  'goal-panel.goal-title.update-error-title': 'Noget gik galt',
  'goal-panel.goal-title.validation-message': 'Angiv en titel til dit mål',
};
